import { ButtonRadioGroupField } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { FromToControl } from '../../../../common/components/from_to_control';
import { IAppState, Dispatch } from '../../../../common/state';
import { FOfferType, isUrban } from '../../../../utils/category';
import {
  changeIsBasement,
  changeIsFirst,
  changeIsSemibasement,
  changeMaxFloor,
  changeMinFloor,
  changeNotLast,
} from '../../../state/advanced/floor';
import { InlineBlock, InlineParam, Row } from '../markup';

const STAGE_MAX_LENGTH = 4;

export interface IFloorProps {
  offerType: FOfferType;

  isBasement: boolean | undefined;
  isFirst: boolean | undefined;
  isSemibasement: boolean | undefined;
  maxFloor: number | undefined;
  minFloor: number | undefined;
  notLast: boolean | undefined;

  onIsBasementChanged(value: boolean | undefined): void;
  onIsFirstChanged(value: boolean | undefined): void;
  onIsSemibasementChanged(value: boolean | undefined): void;
  onMaxFloorChanged(value: number | undefined): void;
  onMinFloorChanged(value: number | undefined): void;
  onNotLastChanged(value: boolean | undefined): void;
}

export const floor: React.StatelessComponent<IFloorProps> = props => (
  <Row title="Этаж">
    <InlineBlock>
      <FromToControl
        rangeGroupStyle={{ width: 120 }}
        from={{
          value: props.minFloor,
          placeholder: 'от',
          onValueChange: props.onMinFloorChanged,
          maxLength: STAGE_MAX_LENGTH,
        }}
        to={{
          value: props.maxFloor,
          placeholder: 'до',
          onValueChange: props.onMaxFloorChanged,
          maxLength: STAGE_MAX_LENGTH,
        }}
      />
    </InlineBlock>

    {isUrban(props.offerType) && (
      <InlineBlock>
        <InlineParam>
          <ButtonCheckbox
            onValueChange={value => props.onIsFirstChanged(value ? !value : undefined)}
            value={props.isFirst === false || false}
          >
            Не первый
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonRadioGroupField
            uncheckable={true}
            value={String(props.notLast)}
            onValueChange={value => props.onNotLastChanged(value !== undefined ? value === 'true' : value)}
            values={[
              { value: 'true', label: 'Не последний' },
              { value: 'false', label: 'Только последний' },
            ]}
          />
        </InlineParam>
      </InlineBlock>
    )}

    {(props.offerType &
      (FOfferType.Office |
        FOfferType.TradeArea |
        FOfferType.Manufacture |
        FOfferType.Warehouse |
        FOfferType.FreeAppointmentObject |
        FOfferType.PublicCatering |
        FOfferType.AutoService |
        FOfferType.DomesticServices)) !==
      0 && (
      <InlineBlock>
        <InlineParam>
          <ButtonCheckbox
            onValueChange={value => props.onIsBasementChanged(value || undefined)}
            value={props.isBasement || false}
          >
            Подвал
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox
            onValueChange={value => props.onIsSemibasementChanged(value || undefined)}
            value={props.isSemibasement || false}
          >
            Полуподвал
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox
            onValueChange={value => props.onIsFirstChanged(value || undefined)}
            value={props.isFirst || false}
          >
            Первый этаж
          </ButtonCheckbox>
        </InlineParam>
      </InlineBlock>
    )}
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect<
  {
    isBasement: boolean | undefined;
    isFirst: boolean | undefined;
    isSemibasement: boolean | undefined;
    maxFloor: number | undefined;
    minFloor: number | undefined;
    notLast: boolean | undefined;
  },
  {
    onIsBasementChanged(value: boolean | undefined): void;
    onIsFirstChanged(value: boolean | undefined): void;
    onIsSemibasementChanged(value: boolean | undefined): void;
    onMaxFloorChanged(value: number | undefined): void;
    onMinFloorChanged(value: number | undefined): void;
    onNotLastChanged(value: boolean | undefined): void;
  },
  {
    offerType: FOfferType;
  }
>(
  (state: IAppState) => ({
    isBasement: state.filters.jsonQuery.is_basement && state.filters.jsonQuery.is_basement.value,
    isFirst: state.filters.jsonQuery.is_first_floor && state.filters.jsonQuery.is_first_floor.value,
    isSemibasement: state.filters.jsonQuery.is_semibasement && state.filters.jsonQuery.is_semibasement.value,
    maxFloor: state.filters.jsonQuery.floor && state.filters.jsonQuery.floor.value.lte,
    minFloor: state.filters.jsonQuery.floor && state.filters.jsonQuery.floor.value.gte,
    notLast: state.filters.jsonQuery.not_last_floor && state.filters.jsonQuery.not_last_floor.value,
  }),
  (dispatch: Dispatch) => ({
    onMinFloorChanged: (value: number | undefined) => {
      dispatch(changeMinFloor(value));
    },
    onMaxFloorChanged: (value: number | undefined) => {
      dispatch(changeMaxFloor(value));
    },
    onIsFirstChanged: (value: boolean | undefined) => {
      dispatch(changeIsFirst(value));
    },
    onNotLastChanged: (value: boolean | undefined) => {
      dispatch(changeNotLast(value));
    },
    onIsBasementChanged: (value: boolean | undefined) => {
      dispatch(changeIsBasement(value));
    },
    onIsSemibasementChanged: (value: boolean | undefined) => {
      dispatch(changeIsSemibasement(value));
    },
  }),
)(floor);
